import { render } from "./CertAlcoholActivePending.vue?vue&type=template&id=30cebe45&scoped=true"
import script from "./CertAlcoholActivePending.vue?vue&type=script&lang=js"
export * from "./CertAlcoholActivePending.vue?vue&type=script&lang=js"

import "./CertAlcoholActivePending.vue?vue&type=style&index=0&id=30cebe45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cebe45"]])

export default __exports__